export const ViewTypeChartEnum = {
    DetailAnswer:1,
    RightAndWrongAnser:2
}